import React from 'react';
import { z_index } from 'const/zIndex';
import CallCenterScreen from 'containers/Player/components/EpgTransactions/CallCenterScreen';
import { useSelector } from 'react-redux';
import { Modal } from 'cvlib';
import './style.scss';
import { getTranslation } from 'utils/getTranslation';

export const WhatIncludesCallcenter = ({
  displayCallCenter,
  setDisplayCallCenter,
}) => {
  const assets  = useSelector(state => state.asset);
  const translations = useSelector(state => state.translations);
  if (!displayCallCenter) return null;

  return (
    <div style={{ zIndex: 9998 }}>
      <h2
        className="player-epg-transactions-exit-button"
        style={{
          position: 'fixed',
          top: 0,
          zIndex: 9999,
        }}
      >
        <span
          className="player-controls-exit-button"
          onClick={() => setDisplayCallCenter(false)}
        >
          {assets?.BotonGeneral_Icono_Regresar ? (
            <img
              alt=""
              src={assets?.BotonGeneral_Icono_Regresar}
              className="player-controls-exit-button__logo"
            />
          ) : (
            <span className="player-controls-exit-button__logo" />
          )}

          {getTranslation('BotonGeneral_TextoTitulo_Salir', translations)}
        </span>
      </h2>
      <Modal
        isOpen={displayCallCenter}
        backgroundStyle={{
          backgroundColor: '#131313',
          opacity: 1,
        }}
        zIndex={9998}
      >
        <CallCenterScreen
          forceCallCenter
          setForceCallCenter={setDisplayCallCenter}
        />
      </Modal>
    </div>
  );
};
